// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__qls5l","column":"Content_column__qCL6s","inner":"Content_inner__qQrCA"};